/** Same-origin iframe written via document.write — the only preview
    technique that works inside the Zoom webview (no window.open, no blob:). */
export function PreviewFrame({ html, title = 'Document preview' }: { html: string; title?: string }) {
  const mount = (el: HTMLIFrameElement | null) => {
    if (!el || el.dataset.written === html.length.toString()) return;
    const frameDoc = el.contentDocument;
    if (!frameDoc) return;
    frameDoc.open();
    frameDoc.write(html);
    frameDoc.close();
    el.dataset.written = html.length.toString();
  };
  return (
    <iframe
      title={title}
      ref={mount}
      className="h-full min-h-[16rem] w-full rounded-md border border-surface-border bg-white"
    />
  );
}
